import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import { ROUTES } from "../../routes/RouterConfig";
import { GrStar } from 'react-icons/gr';
import Container from 'react-bootstrap/Container';
import logo from '../../../assets/images/man.png';
import logo2 from '../../../assets/images/people.png';
import logo3 from '../../../assets/images/girl.png';
import step_1 from '../../../assets/images/step1.jpg';
import step_2 from '../../../assets/images/step2.jpg';
import step_3 from '../../../assets/images/step3.jpg';
import step_4 from '../../../assets/images/step4.jpg';
import step_5 from '../../../assets/images/step5.jpg';
import choose from '../../../assets/images/why_choose_us.jpg';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Footer from '../../../components/footer';
import Header from '../../../components/header';
import { Rating } from '@smastrom/react-rating';
import '@smastrom/react-rating/style.css';
import { CCard, CCardText, CCardBody, CCardImage } from '@coreui/react';
import {
   Accordion,
   AccordionItem,
   AccordionItemHeading,
   AccordionItemButton,
   AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

import Mob1 from '../../../assets/images/bann.png';
import { Button } from 'react-bootstrap';
import { getObjectData } from '../../../services/Storage';
import jwt_decode from 'jwt-decode';
const features = [
   {
      name: 'We only work with the best',
      description: `Only the most qualified Motor Vehicle Inspection Stations are
         invited to our platform/marketplace, guaranteeing you the highest quality of service.
         `,
   },
   {
      name: 'Accountability is key',
      description: `You'll be prompted to review your experience after each transaction you complete with Inspect This Car. This helps us and our affiliates stay in touch with how we're doing and what we can do better.`,
   },
   {
      name: "We're here to shake things up",
      description: `Our sole purpose is to promote honesty, transparency and equitable transactions in the automotive resale space. We are here to make sure your next used car purchase is as exciting and safe as its supposed to be`,
   },
];

const Home = () => {
   const navigate = useNavigate();
   const [rating, setRating] = useState(5);

   const changeDir = (dir) => {
      navigate(dir);
   };
   const [user, setUser] = useState(null);

   useEffect(() => {
      getUserDetails();
   }, []);

   const getUserDetails = async () => {
      try {
         const tokenData = await getObjectData('auth');

         const userData = jwt_decode(tokenData.accessToken);
         if (userData) {
            setUser(userData);
         }
      } catch (error) {
         setUser(null);
      }
   };
   const ratingData = [
      {
         img: logo,
         description:
            "Recently took my vehicle there for the first time for a water pump replacement. They were very friendly, did a great job, didn't charge me any extra fees above their quote, and got it done on time. Very happy with the experience.",
         star: { rating },
         username: 'Robert Parson',
         place: 'Ontario, Canada',
      },

      {
         img: logo2,
         description:
            "Life is good when you have people you can trust to do good work and treat you fairly. Honest & dependable, that's what Auto is to us. When I hear friends talk about their car troubles, I always recommend the mechanics at Inspectthiscar with confidence.",
         star: { rating },
         username: 'Jack Williams',
         place: 'Ottawa, Canada  ',
      },
      {
         img: logo3,
         description:
            "I'm always happy with my service. Inspectthiscar does a great job at keeping me updated on what is needed on my vehicle. He is very knowledgeable and easy to work with. It's nice to have the peace of mind, knowing everything is done correctly.",
         star: { rating },
         username: 'Sarah Williams',
         place: 'Ottawa, Canada  ',
      },
   ];

   return (
      <div className="Home">
         <Header />
         <section>
            <Container fluid="sm">
               <div className="relative isolate px-6  lg:px-8">
                  <div
                     className="absolute  top-0 -z-10 transform-gpu overflow-hidden blur-3xl sm:top-0"
                     aria-hidden="true"
                  >
                     <div
                        className="relative left-[calc(50%-11rem)] aspect-[1155/678]  md:w-[36.125rem] w-[16.125rem] lg:w-[36.125rem] -translate-x-1/5 rotate-[30deg] bg-gradient-to-tr from-[#0168FF] to-[#20F8FA] opacity-50 sm:left-[calc(50%-30rem)] sm:w-[60.1875rem]"
                        style={{
                           clipPath:
                              'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                     />
                  </div>
                  <div className="flex justify-center item-center rounded-lg">
                     <iframe
                        className="rounded-md box"
                        width="700"
                        height="315"
                        src="https://www.youtube.com/embed/4uNuXhXlcbY?si=ygGY97cuOBg7TRS5"
                        // title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                     ></iframe>
                  </div>
                  <div className="mx-auto text-center max-w-4xl pt-8 sm:pt-8 lg:pt-8">
                     <h1 className="text-xl font-bold tracking-tight text-[#001D47] lg:text-3xl md:text-2xl sm:text-xl">
                        The Most Trusted & Comprehensive Car Inspections from
                        Inspect This Car' Network of Exclusively Selected Motor
                        Vehicle Inspection Stations
                     </h1>
                     <div className="mt-4 flex items-center justify-center gap-x-6">
                        {user && user?.email ? (
                           <Button
                              // size='large'
                              // href="/user/search-station"
                              href="/user/request-inspection"
                              className="bg-[#0168FF]  rounded-md border-none text-white font-medium h-12 text-md btn-lg"
                           >
                              Request Inspection
                           </Button>
                        ) : (
                           <Button
                              // size='large'
                              // href="/login"
                              href="/request-inspection"
                              className="bg-[#0168FF]  rounded-md border-none text-white font-medium h-12 text-md btn-lg"
                           >
                              Request Inspection
                           </Button>
                        )}
                     </div>
                     <p className="mt-6 text-lg leading-8 text-black">
                        Our meticulously selected group of Motor Vehicle
                        Inspection Stations are dedicated to making your next
                        used car purchase the way it should be; EASY! Our
                        Affiliates are a carefully selected group of Motor
                        Vehicle Inspection Stations entrusted to offer the
                        absolute highest quality of standards and service. We're
                        here to keep you safe, happy and secure on the road
                        ahead - schedule your inspection today!
                     </p>
                  </div>
               </div>
            </Container>
         </section>
         <section className="py-10 bg-[#fff]">
            <Container fluid="sm">
               <div className="text-center">
                  <h1 className="text-2xl font-bold tracking-tight text-[#001D47] lg:text-5xl md:text-4xl sm:text-5xl">
                     How It Works
                  </h1>
                  <p className="mt-6 text-lg leading-8 text-black">
                     Booking a car inspection with us is quick and hassle-free.
                     Here is how it works.
                  </p>
               </div>

               <div className="flex items-center justify-between mt-5 mb-2">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5  w-[98%] mx-auto">
                     <CCard className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow duration-500 ease-in-out">
                        <div className="h-90 w-64">
                           <img
                              src={step_1}
                              className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-500 ease-in-out"
                           />
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/75 group-hover:via-black/65 group-hover:to-black/70 transition-all duration-500 ease-in-out"></div>
                        <div className="absolute inset-0 flex flex-col items-center px-4  justify-center text-center translate-y-[60%] group-hover:translate-y-0 transition-transform duration-500 ease-in-out">
                           <h1 className="text-xl font-bold text-white mt-10">
                              Select Your Service & Available Times
                           </h1>
                        </div>
                     </CCard>

                     <CCard className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow duration-500 ease-in-out">
                        <div className="h-90 w-64">
                           <img
                              src={step_2}
                              className=" w-full object-cover  group-hover:scale-110 transition-transform duration-500 ease-in-out"
                           />
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/75 group-hover:via-black/65 group-hover:to-black/70 transition-all duration-500 ease-in-out"></div>
                        <div className="absolute inset-0 flex flex-col items-center px-4  justify-center text-center translate-y-[60%] group-hover:translate-y-0 transition-transform duration-500 ease-in-out">
                           <h1 className="text-xl font-bold text-white mt-10">
                              Tell Us About Your Vehicle
                           </h1>
                        </div>
                     </CCard>

                     <CCard className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow duration-500 ease-in-out">
                        <div className="h-90 w-64">
                           <img
                              src={step_3}
                              className=" w-full object-cover  group-hover:scale-110 transition-transform duration-500 ease-in-out"
                           />
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/75 group-hover:via-black/65 group-hover:to-black/70 transition-all duration-500 ease-in-out"></div>
                        <div className="absolute inset-0 flex flex-col items-center px-4  justify-center text-center translate-y-[60%] group-hover:translate-y-0 transition-transform duration-500 ease-in-out">
                           <h1 className="text-xl font-bold text-white mt-10">
                              Set Your Search Area
                           </h1>
                        </div>
                     </CCard>

                     <CCard className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow duration-500 ease-in-out">
                        <div className="h-90 w-64">
                           <img
                              src={step_4}
                              className=" w-full object-cover  group-hover:scale-110 transition-transform duration-500 ease-in-out"
                           />
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/75 group-hover:via-black/65 group-hover:to-black/70 transition-all duration-500 ease-in-out"></div>
                        <div className="absolute inset-0 flex flex-col items-center px-4  justify-center text-center translate-y-[60%] group-hover:translate-y-0 transition-transform duration-500 ease-in-out">
                           <h1 className="text-xl font-bold text-white mt-10">
                              Submit Your Request
                           </h1>
                        </div>
                     </CCard>

                     <CCard className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow duration-500 ease-in-out">
                        <div className="h-90 w-64">
                           <img
                              src={step_5}
                              className=" w-full object-cover  group-hover:scale-110 transition-transform duration-500 ease-in-out"
                           />
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/75 group-hover:via-black/65 group-hover:to-black/70 transition-all duration-500 ease-in-out"></div>
                        <div className="absolute inset-0 flex flex-col items-center px-4  justify-center text-center translate-y-[60%] group-hover:translate-y-0 transition-transform duration-500 ease-in-out">
                           <h1 className="text-xl font-bold text-white mt-10">
                              Review Offers & Secure Your Appointment
                           </h1>
                        </div>
                     </CCard>
                  </div>
               </div>
            </Container>
         </section>
         <section>
            <div className="overflow-hidden bg-white py-10">
               <Container fluid="sm">
                  <div className="mx-auto grid max-w-7xl grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-16 items-center">
                     <div className="flex justify-center">
                        <img
                           src={choose}
                           alt="Why Choose Us"
                           className="w-[90%] h-auto shadow-xl rounded-lg object-cover"
                        />
                     </div>
                     <div className="lg:pl-0 lg:pt-0">
                        <div>
                           <h2 className="text-4xl font-semibold text-[#001D47] mb-8">
                              Why Choose Us
                           </h2>

                           <dl className="space-y-8">
                              {features.map((feature) => (
                                 <div
                                    key={feature.name}
                                    className="relative"
                                 >
                                    <h2 className="mb-2 font-semibold text-[#001D47] text-2xl">
                                       {feature.name}
                                    </h2>
                                    <dd className="mt-2 text-base text-[#1C1C1C]">
                                       {feature.description}
                                    </dd>
                                 </div>
                              ))}
                           </dl>
                        </div>
                     </div>
                  </div>
               </Container>
            </div>
         </section>
         <section>
            <div className="overflow-hidden bg-white py-6">
               <div className="mx-auto">
                  <div className="mx-auto lg:flex-nowrap md:flex-nowrap wrp flex max-w-2xl gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none">
                     <div className="lg:pr-8 lg:pt-4 w-full">
                        <div className="lg:max-w-2xl mx-auto">
                           <h2 className="lg:text-4xl md:text-4xl sm:text-3xl text-2xl font-semibold text-[#001D47] mb-3">
                              Frequently Asked Questions
                           </h2>
                           <Accordion>
                              <AccordionItem>
                                 <AccordionItemHeading>
                                    <AccordionItemButton>
                                       What does an MVIS stand for?
                                    </AccordionItemButton>
                                 </AccordionItemHeading>
                                 <AccordionItemPanel className="bg-[#fff] px-3 py-3">
                                    <p>
                                       Motor Vehicle Inspection Station; an
                                       inspection station licensed by the
                                       Ontario Ministry of Transportation (MTO).
                                       Look for this sign:
                                    </p>
                                 </AccordionItemPanel>
                              </AccordionItem>
                              <AccordionItem>
                                 <AccordionItemHeading>
                                    <AccordionItemButton>
                                       How Much is a Safety Inspection for my
                                       vehicle?
                                    </AccordionItemButton>
                                 </AccordionItemHeading>
                                 <AccordionItemPanel className="bg-[#fff] px-3 py-3">
                                    <p>
                                       The Safety Standards Inspection is $150
                                       and it covers the Provincially Mandated
                                       Motor Vehicle Inspection procedure as
                                       prescribed by the Ontario Ministry of
                                       Transportation. This cost includes the
                                       price of inspection and certification.
                                    </p>
                                 </AccordionItemPanel>
                              </AccordionItem>
                              <AccordionItem>
                                 <AccordionItemHeading>
                                    <AccordionItemButton>
                                       Why is the Pre-Purchase Inspection more
                                       costly than the Safety Inspection?
                                    </AccordionItemButton>
                                 </AccordionItemHeading>
                                 <AccordionItemPanel className="bg-[#fff] px-3 py-3">
                                    <p>
                                       The Pre-Purchase inspection is a far more
                                       comprehensive inspection process which
                                       covers 300 vehicle reference points.
                                       While the Safety Standards inspection
                                       covers reference points required for the
                                       safe operation of a motor vehicle, the
                                       pre-purchase inspection covers points
                                       which fall outside the purview of basic
                                       safety standards. For example, distressed
                                       upholstery, worn spark plugs, dirty
                                       oil/fluids or malfunctioning media
                                       systems might be important when deciding
                                       whether to purchase a vehicle, yet they
                                       are not considered Provincially mandated
                                       safety standards. This added scrutiny
                                       contributes to a greater use of the Motor
                                       Vehicle Inspection Stations time and
                                       effort which translates to a higher
                                       service cost.
                                    </p>
                                 </AccordionItemPanel>
                              </AccordionItem>
                              <AccordionItem>
                                 <AccordionItemHeading>
                                    <AccordionItemButton>
                                       Do I have to wait at the Inspection
                                       Station while my vehicle is being
                                       inspected?
                                    </AccordionItemButton>
                                 </AccordionItemHeading>
                                 <AccordionItemPanel className="bg-[#fff] px-3 py-3">
                                    <p>
                                       Once you choose a time and date that best
                                       fits your schedule, we recommend enjoying
                                       the down time in the designated waiting
                                       area while your inspection is being
                                       completed. Most safety inspections can
                                       take about an hour. A pre-purchase
                                       inspection may take longer as it requires
                                       greater scrutiny. Although time is a
                                       desirable standard, we firmly believe in
                                       taking good care when evaluating a
                                       vehicle's safety.
                                    </p>
                                 </AccordionItemPanel>
                              </AccordionItem>
                              <AccordionItem>
                                 <AccordionItemHeading>
                                    <AccordionItemButton>
                                       Why can't the inspection be done
                                       remotely?
                                    </AccordionItemButton>
                                 </AccordionItemHeading>
                                 <AccordionItemPanel className="bg-[#fff] px-3 py-3">
                                    <p>
                                       Although a pre-purchase inspection can
                                       technically be done remotely, the
                                       Provincially mandated Motor Vehicle
                                       Safety Inspection requires a vehicle to
                                       be inspected within a designated Motor
                                       Vehicle Inspection Station in order to
                                       qualify for a Safety Standards
                                       Certificate.
                                    </p>
                                 </AccordionItemPanel>
                              </AccordionItem>
                              <AccordionItem>
                                 <AccordionItemHeading>
                                    <AccordionItemButton>
                                       How do I receive my Safety Standards
                                       Certificate?
                                    </AccordionItemButton>
                                 </AccordionItemHeading>
                                 <AccordionItemPanel className="bg-[#fff] px-3 py-3">
                                    <p>
                                       Your Safety Standards Certificate will be
                                       assigned upon the completion and
                                       satisfaction of all safety related
                                       repairs or requirements. This certificate
                                       is provided by the affiliated Motor
                                       Vehicle Inspection Station upon
                                       completion of required service at the
                                       time of vehicle pick up. The Safety
                                       Certificate expires 36 days from the date
                                       of issue. Note* The Safety Standards
                                       Certificate is scheduled for digitization
                                       within the year. At such a point, the
                                       Safety Standards Certificate will be
                                       digitally assigned to the vehicle's VIN,
                                       eliminating the antiquated paper
                                       certificate.
                                    </p>
                                 </AccordionItemPanel>
                              </AccordionItem>
                              <AccordionItem>
                                 <AccordionItemHeading>
                                    <AccordionItemButton>
                                       Do I have to agree to the estimate
                                       provided to secure Provincial Safety
                                       Standards?
                                    </AccordionItemButton>
                                 </AccordionItemHeading>
                                 <AccordionItemPanel className="bg-[#fff] px-3 py-3">
                                    <p>
                                       No, you have full authority to refuse the
                                       recommended service upon receipt of your
                                       estimate. If any service/repairs are
                                       required, they must be completed within
                                       10 days from the date of inspection in
                                       order to qualify for a Safety Standards
                                       Certificate. Once repairs are complete,
                                       you can have the vehicle reassessed by
                                       the original MVIS in order to obtain your
                                       Provincial Safety Standards Certificate.
                                       Additional charges may apply for
                                       reinspection at the discretion of the
                                       MVIS.
                                    </p>
                                 </AccordionItemPanel>
                              </AccordionItem>
                              <AccordionItem>
                                 <AccordionItemHeading>
                                    <AccordionItemButton>
                                       What if I'm not satisfied with the
                                       service?
                                    </AccordionItemButton>
                                 </AccordionItemHeading>
                                 <AccordionItemPanel className="bg-[#fff] px-3 py-3">
                                    <p>
                                       All transactions are subject to a formal
                                       review and rated assessment of service (1
                                       to 5 Stars){' '}
                                       <span
                                          style={{
                                             background: 'red',
                                             color: 'white',
                                          }}
                                       ></span>{' '}
                                       Inspect This Car strives to be the Gold
                                       Standard for all vehicle inspection
                                       needs, but from time to time,
                                       expectations may not be met. If for any
                                       reason, you're not satisfied with your
                                       inspection result, we will do everything
                                       possible to reach an amicable and
                                       satisfactory resolution between our
                                       affiliate and customer.
                                    </p>
                                 </AccordionItemPanel>
                              </AccordionItem>
                              <AccordionItem>
                                 <AccordionItemHeading>
                                    <AccordionItemButton>
                                       How long do I have to satisfy safety
                                       inspection requirements in order to
                                       receive my safety certificate?
                                    </AccordionItemButton>
                                 </AccordionItemHeading>
                                 <AccordionItemPanel className="bg-[#fff] px-3 py-3">
                                    <p>
                                       If any service/repairs are required, they
                                       must be completed within 10 days of the
                                       inspection to maintain certificate
                                       eligibility, as per Provincial
                                       requirements. Once repairs are complete,
                                       you can have the vehicle reassessed by
                                       the original MVIS in order to obtain your
                                       Provincial Safety Standards Certificate.
                                       Additional charges may apply for
                                       reinspection at the discretion of the
                                       MVIS.
                                    </p>
                                 </AccordionItemPanel>
                              </AccordionItem>
                              <AccordionItem>
                                 <AccordionItemHeading>
                                    <AccordionItemButton>
                                       I got my Safety or Pre-Purchase
                                       Inspection, now what?
                                    </AccordionItemButton>
                                 </AccordionItemHeading>
                                 <AccordionItemPanel className="bg-[#fff] px-3 py-3">
                                    <p>
                                       <span
                                          style={{
                                             background: 'red',
                                             color: 'white',
                                          }}
                                       >
                                          *Stand by for Video*
                                       </span>
                                       See our "Complete A-Z : How to register a
                                       used vehicle in Ontario" video for
                                       further guidance on what to expect.
                                    </p>
                                 </AccordionItemPanel>
                              </AccordionItem>
                           </Accordion>
                        </div>
                     </div>
                     <div className="w-full contents">
                        <img
                           src={require('../../../assets/images/half.png')}
                           alt="Product screenshot"
                           className="w-full lg:w-4/12 md:w-4/12 sm:w-4/12"
                        />
                     </div>
                  </div>
               </div>
            </div>
         </section>

         <section>
            <div className="mx-auto max-w-[85%] mb-4 ">
               <div className="grid md:grid-cols-3 md:gap-y-20 xs:grid-cols-1 sm:grid-cols-2 sm:gap-x-20 ">
                  {ratingData.map((data, index) => (
                     <div
                        class="max-w-2xl mx-4 sm:max-w-sm md:max-w-sm lg:max-w-sm xl:max-w-sm sm:mx-auto md:mx-auto lg:mx-auto xl:mx-auto mt-16 bg-white shadow-xl rounded-lg text-gray-900"
                        key={index}
                     >
                        <div class="rounded-t-lg h-40 overflow-hidden">
                           <img
                              class="object-cover object-top w-full"
                              src="https://img.freepik.com/free-photo/bike-creation-workshop_23-2148866632.jpg?t=st=1718186041~exp=1718189641~hmac=79a381d37496ce50937ff96f4f1c4398f88d868ab19fb0faae573dd8d711d457&w=826"
                              alt="Mountain"
                           />
                        </div>
                        <div class="mx-auto w-24 h-24 relative -mt-16 border-4 border-white rounded-full overflow-hidden">
                           <img
                              class="object-contain -mt-3 h-32 bg-slate-600"
                              src={data.img}
                              alt="Woman looking front"
                           />
                        </div>
                        <div class="text-center mt-3">
                           <div className="flex justify-center">
                              <Rating
                                 style={{ maxWidth: 130, alignItems: 'center' }}
                                 value={rating}
                                 readOnly
                                 // onChange={setRating}
                              />
                           </div>

                           <h2 class="font-semibold mt-1">{data.username}</h2>
                           <p class="text-gray-500 mt-0">{data.place}</p>
                        </div>

                        <div class=" px-8 py-3 text-gray-700 flex items-center justify-around">
                           {data.description}
                        </div>
                     </div>
                  ))}
               </div>
            </div>
         </section>

         <Footer />
      </div>
   );
};

export default Home;
